import type { Directive } from 'vue';

function patchSelectInputs(root: HTMLElement): void {
  root.querySelectorAll('input').forEach((input) => {
    if (input.closest('.is-filterable')) {
      return;
    }
    input.setAttribute('inputmode', 'none');
    input.setAttribute('enterkeyhint', 'done');
  });
}

/**
 * Evita que el input interno de `el-select` dispare el teclado del sistema en móvil.
 * Aplicar solo cuando `filterable` está desactivado.
 */
export const preventSelectKeyboard: Directive<HTMLElement, boolean | undefined> = {
  mounted(el, binding) {
    if (binding.value === false) {
      return;
    }
    patchSelectInputs(el);
    const observer = new MutationObserver(() => patchSelectInputs(el));
    observer.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    (el as HTMLElement & { _preventSelectKeyboardObserver?: MutationObserver })._preventSelectKeyboardObserver =
      observer;
  },
  updated(el, binding) {
    if (binding.value === false) {
      return;
    }
    patchSelectInputs(el);
  },
  unmounted(el) {
    const observer = (el as HTMLElement & { _preventSelectKeyboardObserver?: MutationObserver })
      ._preventSelectKeyboardObserver;
    observer?.disconnect();
  },
};
